import { Card } from "@/components/ui/card";

export function KpiCard({ label, value, meta, testid, accent = "text-primary" }) {
  return (
    <Card className="bg-card border-border p-4" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className={`mt-2 text-3xl font-display font-semibold tabular-nums ${accent}`}>{value}</div>
      {meta && <div className="mt-2 text-xs text-muted-foreground">{meta}</div>}
    </Card>
  );
}
